import { Path, Node, Editor, Element, PathRef } from 'domains/reporter/RichTextEditor/core';
import { HeadingLevel } from '../../RichTextEditor/plugins/heading/constants';
import {
  isHeadingNode,
  removePunctuationAndWhitespace,
} from '../../RichTextEditor/plugins/heading/utils/normalization';
import { isEligibleNamedField } from '../../RichTextEditor/utils/fieldNaming';
import {
  InlineBookmarkElement,
  PicklistPluginElement,
} from 'domains/reporter/RichTextEditor/slate-custom-types';

export type NavigationItem = {
  name: string;
  node: Node;
  path: Nullable<PathRef>;
};

export const getNavigationItemsFromEditor = (editor?: Editor | null): Array<NavigationItem> => {
  const items: Array<Nullable<NavigationItem>> = [];
  if (editor?.children == null) {
    return [];
  }

  for (const [node, path] of Array.from(Node.nodes(editor))) {
    items.push(getNavigationItem(node, path, editor));
  }
  return items.filter((node) => node != null);
};

export const getNavigationItem = (
  node: Node,
  path?: Path | null,
  editor?: Editor | null
): Nullable<NavigationItem> => {
  if (isHeadingNode(node, HeadingLevel.H1)) {
    return {
      node,
      name: removePunctuationAndWhitespace(Node.string(node)),
      path: path != null && editor != null ? Editor.pathRef(editor, path) : null,
    };
  } else if (Element.isElement(node) && isEligibleNamedField(node.type)) {
    return {
      node,
      name: removePunctuationAndWhitespace(
        (node as PicklistPluginElement | InlineBookmarkElement).name ?? ''
      ),
      path: path != null && editor != null ? Editor.pathRef(editor, path) : null,
    };
  }

  return null;
};
